import { types } from "./types.js";

class Objects {
  // maybe should check if structured clone methods exists,
  // if it does, call make a deep copy with JSON object
  // and custom parsers for Map, Set and Date objects
  clone(object) {
    try {
      return structuredClone(object);
    } catch {
      // doesn't copy properties with value `undefined`
      return JSON.parse(JSON.stringify(object));
    }
  }

  _toKeys(x) {
    return types.isArray(x) ? [...x] : x.toString().split(/[.:]/);
  }

  get(x, keys) {
    if (x !== null && types.isTraversable(x)) {
      const chain = this._toKeys(keys);
      let key = chain.shift();
      while (chain.length > 0) {
        if (x[key]) {
          x = x[key];
          key = chain.shift();
        } else {
          return x[key];
        }
      }
      return chain.length > 0 ? undefined : x[key];
    }
  }

  set(object, keys, value) {
    if (types.isTraversable(object)) {
      const chain = this._toKeys(keys);
      let key = chain.shift();
      while (chain.length > 0) {
        if (object[key] === undefined) {
          const next = Number.parseInt(chain[0]);
          object[key] = types.isInt(next) ? [] : {};
        }
        object = object[key];
        key = chain.shift();
      }
      object[key] = value;
      return value;
    }
  }
}

const objects = new Objects();
export { Objects, objects };